import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HideCollapseDirective } from '../../directives/hide-collapse.directive';
import { IconCloseComponent } from '../icon-close/icon-close.component';

type Variant = 'neutral' | 'success' | 'danger';

const variantClassMapper: Record<Variant, string> = {
  neutral: 'bewp-standard-banner--neutral',
  success: 'bewp-standard-banner--success',
  danger: 'bewp-standard-banner--danger',
};

@Component({
  selector: 'app-notification-banner-standard',
  templateUrl: './notification-banner-standard.component.html',
  styleUrls: ['./notification-banner-standard.component.scss'],
  imports: [CommonModule, IconCloseComponent, HideCollapseDirective],
})
export class NotificationBannerStandardComponent {
  @Input() set variant(variant: Variant) {
    this.variantClass = this.getVariantClass(variant);
  }
  @Output() afterClose: EventEmitter<any> = new EventEmitter();

  variantClass = 'bewp-standard-banner--neutral';

  getVariantClass(variant: Variant): string {
    return variantClassMapper[variant];
  }
}
